import { useNavigate } from 'react-router-dom';
import { DEFAULT_GAME_SLUG } from '../config';
import { ErrorState, LoadingState } from '../components/LoadingState';
import { Theme } from '../components/Theme';
import { useGame } from '../hooks/useGame';
import { ProgressService } from '../services/progressService';

export function LandingPage() {
  const navigate = useNavigate();
  const { game, loading, error } = useGame(DEFAULT_GAME_SLUG);
  if (loading) return <LoadingState />;
  if (error || !game) return <ErrorState message={error || 'Juego no encontrado.'} />;
  const hasProgress = Boolean(ProgressService.load(game)?.completedModules.length);
  return (
    <Theme theme={game.theme}>
      <main className="landing center-screen">
        <div className="sparkles" aria-hidden="true">✦ · ♥ · ✦</div>
        <section className="landing-card">
          <p className="eyebrow">Una aventura para dos</p>
          <h1>{game.title}</h1>
          <p className="landing-description">{game.description}</p>
          <button className="button button-primary button-large" onClick={() => navigate(`/game/${game.slug}`)}>
            {hasProgress ? 'Continuar aventura' : 'Comenzar'} <span aria-hidden="true">→</span>
          </button>
          <p className="landing-note">Tus recuerdos quedan guardados en este dispositivo.</p>
        </section>
      </main>
    </Theme>
  );
}
